/**
 * Vendor bundle — exposes third-party libraries as globals so existing
 * template inline-scripts and module code can reach them without CDN.
 *
 * Bundled here: Bootstrap (JS + CSS), Lucide icons, Chart.js
 * Import this before any application scripts.
 */

import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap';
import * as lucide from 'lucide';
import Chart from 'chart.js/auto';

window.bootstrap = bootstrap;

// `import * as lucide` yields a read-only ES-module namespace object, so we
// can't patch createIcons on it directly. Expose a mutable shallow copy and
// override createIcons to inject the icons set that the ESM build requires.
const lucideGlobal = { ...lucide };
const _origCreateIcons = lucide.createIcons.bind(lucide);
lucideGlobal.createIcons = (opts = {}) => _origCreateIcons({ icons: lucide.icons, ...opts });
window.lucide = lucideGlobal;

window.Chart = Chart;
